import { onError } from '@apollo/client/link/error'

const UNDER_MAINTENANCE_STATUS_CODE = 503

const PHARMACY_SUPPORT_WEB_CLIENT_ID = 'pharmacy-support-web'

// メンテナンスモード有効時(ステータス503)、メンテナンス画面へリダイレクトする
export const createMaintenanceCheckLink = () => {
  return onError(({ networkError }) => {
    if (
      networkError &&
      'statusCode' in networkError &&
      networkError.statusCode === UNDER_MAINTENANCE_STATUS_CODE
    ) {
      const params = new URLSearchParams({ client_id: PHARMACY_SUPPORT_WEB_CLIENT_ID })
      window.location.href = `${window.location.origin}/maintenance?${params.toString()}`
    }
  })
}
